import { LegacyBox, styled } from '@gogame/components';

export const Header = styled(LegacyBox)`
  padding: 16px;
  height: 64px;
`;
